import { motion } from "framer-motion";
import HeroImage from "../assets/Hero.jpeg";
import HeroImagePortrait from "../assets/port.png";

export function Hero() {
  return (
    <div className="relative h-screen w-full max-w-full overflow-hidden flex items-center justify-center">
      {/* Landscape image */}
      <div className="absolute inset-0 z-0 hidden md:block">
        <img
          src={HeroImage}
          alt="Students studying in a historic library"
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
          fetchPriority="high"
          loading="eager"
        />
      </div>

      {/* Portrait image */}
      <div className="absolute inset-0 z-0 block md:hidden">
        <img
          src={HeroImagePortrait}
          alt="Students studying in a historic library"
          className="w-full h-full object-cover"
          width="1080"
          height="1920"
          fetchPriority="high"
          loading="eager"
        />
      </div>

      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          delay: 1,
          duration: 1,
        }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/80 flex flex-col items-center gap-2"
      >
        <span className="text-xs uppercase tracking-widest">
          Scroll to Explore
        </span>
        <motion.div
          animate={{
            y: [0, 8, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="w-px h-12 bg-gradient-to-b from-white to-transparent"
        />
      </motion.div>
    </div>
  );
}
